<template>
  <notice-dialog
    :show.sync="localShow"
    :title="title"
    :message="content"
    primary-text="繼續購物"
    primary-type="main-color"
    @primary="onClose"
  />
</template>

<script>
import NoticeDialog from "@/components/dialogs/NoticeDialog.vue";

export default {
  name: "SuccessDialog",
  components: { NoticeDialog },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '下單成功',
    },
    message: {
      type: String,
      default: '',
    },
    meta: {
      type: Object,
      default: null,
    },
  },
  computed: {
    localShow: {
      get() { return this.show; },
      set(v) { this.$emit('update:show', v); },
    },
    content() {
      return this.message || '下單成功';
    }
  },
  methods: {
    onViewOrder() {
      const meta = this.meta || {};
      const orderId = meta.orderId || meta.order_id;
      this.$emit('update:show', false);
      if (orderId) this.$router.push(`/order/${orderId}`);
      else this.$router.push('/order');
    },
    onClose() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped>
.text-center p { margin: 0; }

.modal-header {
  border-bottom: none !important;
}
.modal-footer {
  border-top: none !important;
}
.text-orange {
  color: #f0a500;
}
</style>


